import React from 'react';
import { FaEye, FaPen, FaArchive, FaUndoAlt } from 'react-icons/fa';

const ReportTable = ({
  columns = [
    { key: 'date', label: 'Date' },
    { key: 'submitted', label: 'Submitted By' },
    { key: 'last_modified', label: 'Last Modified' },
  ],
  data = [],
  isLoading = false,
  statusFilter = 0,
  title = 'reports',
  emptyMessage,
  emptySubMessage,
  onView,
  onEdit,
  onArchive,
  onRestore,
}) => {
  return (
    <div className="bg-white rounded-xl border border-aimhi-border shadow-xs overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-aimhi-light border-b border-aimhi-border text-[11px] font-semibold text-aimhi-textlight-neutral uppercase tracking-wider">
              {columns.map((col, idx) => (
                <th key={col.key || idx} className={`py-3 px-4 ${col.headerClassName || ''}`}>
                  {col.label}
                </th>
              ))}
              <th className="py-3 px-4 text-right">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 text-xs">
            {isLoading ? (
              <tr>
                <td colSpan={columns.length + 1} className="py-8 text-center text-aimhi-textlight-muted">
                  Loading {title.toLowerCase()}...
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan={columns.length + 1} className="py-12 text-center text-aimhi-textlight-muted">
                  <p className="text-sm font-medium m-0">{emptyMessage || `No ${title.toLowerCase()} found`}</p>
                  {emptySubMessage && <p className="text-xs m-0 mt-1">{emptySubMessage}</p>}
                </td>
              </tr>
            ) : (
              data.map((reportItem, index) => (
                <tr
                  key={reportItem.report_log_id || reportItem.id || index}
                  className="hover:bg-gray-50/80 transition-colors"
                >
                  {columns.map((col, colIdx) => (
                    <td
                      key={col.key || colIdx}
                      className={`py-3 px-4 ${colIdx === 0
                        ? 'font-semibold text-aimhi-textlight-neutral'
                        : 'text-aimhi-textlight-neutral'
                        } ${col.className || ''}`}
                    >
                      {colIdx === 0 && onView ? (
                        <button
                          type="button"
                          onClick={() => onView(reportItem)}
                          className="text-aimhi-textlight-neutral hover:text-aimhi-info hover:underline font-semibold bg-transparent border-0 p-0 cursor-pointer text-left"
                        >
                          {col.render ? col.render(reportItem[col.key], reportItem) : reportItem[col.key]}
                        </button>
                      ) : col.render ? (
                        col.render(reportItem[col.key], reportItem)
                      ) : (
                        reportItem[col.key] || '—'
                      )}
                    </td>
                  ))}
                  <td className="py-3 px-4 text-right">
                    <div className="inline-flex items-center justify-end gap-1.5">
                      {onView && (
                        <button
                          type="button"
                          title="View Details"
                          onClick={() => onView(reportItem)}
                          className="p-1.5 rounded-md text-aimhi-textlight-muted hover:text-aimhi-textlight-neutral hover:bg-gray-100 transition-colors cursor-pointer"
                        >
                          <FaEye className="text-xs" />
                        </button>
                      )}

                      {statusFilter === 0 ? (
                        <>
                          {onEdit && (
                            <button
                              type="button"
                              title="Edit Report"
                              onClick={() => onEdit(reportItem)}
                              className="p-1.5 rounded-md text-aimhi-textlight-muted hover:text-aimhi-info hover:bg-aimhi-info/10 transition-colors cursor-pointer"
                            >
                              <FaPen className="text-xs" />
                            </button>
                          )}
                          {onArchive && (
                            <button
                              type="button"
                              title="Archive Report"
                              onClick={() => onArchive(reportItem)}
                              className="p-1.5 rounded-md text-aimhi-textlight-muted hover:text-aimhi-danger hover:bg-aimhi-danger/10 transition-colors cursor-pointer"
                            >
                              <FaArchive className="text-xs" />
                            </button>
                          )}
                        </>
                      ) : (
                        onRestore && (
                          <button
                            type="button"
                            title="Restore Report"
                            onClick={() => onRestore(reportItem)}
                            className="p-1.5 rounded-md text-aimhi-textlight-muted hover:text-aimhi-primary hover:bg-aimhi-primary/10 transition-colors cursor-pointer"
                          >
                            <FaUndoAlt className="text-xs" />
                          </button>
                        )
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReportTable;
